import request from '@/utils/request'
import qs from 'qs'

export function getTodos(query) {
  return request({
    url: '/api/srm-base/appProcess/todoList',
    method: 'get',
    params: query
  })
}

export function opinionTask(id) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/hisInstance/v1/nodeOpinion?instId=' + id,
    method: 'get'
  })
}

export function getTaskBtn(taskId) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/getTaskBtn/' + taskId,
    method: 'get'
  })
}

export function saveVariables(processId, data) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/cockpit/activity/variables/runtime/save/' + processId,
    method: 'post',
    data
  })
}

export function getNextNode(taskId, params) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/cockpit/process-instance/getNextNode/' + taskId,
    method: 'get',
    params
  })
}

export function completeTask(data) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/task/v3/complete',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export function changeActivity(data) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/cockpit/task/v1/anyway/changeActivity/' + data.taskId,
    method: 'POST',
    data: qs.stringify(data)
  })
}

export function invalidTask(id) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/history/task/v1/invalid/' + id,
    method: 'get'
  })
}

export function getBackNode(taskId) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/task/v1/getBackNode/' + taskId,
    method: 'GET'
  })
}

export function getBackNodeUser(taskId, nodeId) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/task/v1/getBackNodeUser/' + taskId + '/' + nodeId,
    method: 'GET'
  })
}
